import { TransactionDetailModel } from 'src/app/models/transaction-detail-model';
import { CommonFunctionService,UserMerchantData } from './../Common/common-function.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { environment } from '../../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { VposPrepaidCardsAppView } from 'src/app/models/vpos-prepaid-cards-app-view';
import { VposPaymentTransactionAppView } from 'src/app/models/vpos-payment-transaction-app-view';
import { TransactionResponse } from 'src/app/models/transaction-response';
import { Merchantservicesandfee } from 'src/app/models/merchantservicesandfee';
import { PaymentOrderDetailsModel } from 'src/app/models/payment-order-details-model';
import { Observable, catchError, map } from 'rxjs';
import { shareReplay } from 'rxjs/operators';


@Injectable()
export class TransactionService {
  userId: any;
  token;
  headers: any;
  private userRolePermissionsCache: Observable<any> = null;

  constructor(private service: DataService,private http: HttpClient, private common:CommonFunctionService) { 

    const helper = new JwtHelperService();

    // if (localStorage.getItem('VirtualPOSToken') != null) {
    // this.token=helper.decodeToken(localStorage.getItem('VirtualPOSToken'));
    // this.headers = new HttpHeaders(). 
    // set('Authorization', 'Bearer '+this.token);
    // }
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  }
  AddTransaction(data,TransactionType)
  {
    this. GetHeaderdetails();
    //data.UserId=this.userId;
    return this.http.post<TransactionResponse>(environment.NewTransactionUrl+"?tranType="+TransactionType,data,{headers:this.headers});
  }
  GetServiceStatus(data,MerchantKeyId)
  {this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<Merchantservicesandfee[]>(environment.GetServiceStatusUrl+"?serviceCode="+data+"&MerchantKeyId="+MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})   
    .pipe(catchError(this.common.handleError));
  }
  GetTransactions(data) 
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<TransactionDetailModel>(environment.GetTransactionUrl+"?MerchantKeyId="+ data +"&LoginUserId="+merchantdata.UserId
    +data,{headers:this.headers})   
    .pipe(catchError(this.common.handleError));
  } 
  ViewTransaction(data,MerchantKeyId,paymentType)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposPaymentTransactionAppView>(environment.ViewTransactionUrl+"?id="+data+"&MerchantKeyId="+MerchantKeyId+"&PaymentType="+paymentType+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  } 
  VoidTransaction(data,TransactionType,email)
  {
    return this.http.post(environment.VoidTransactionUrl+"?tranType="+TransactionType+"&Email="+email,data,{headers:this.headers});
  } 
// RefundTransaction(data,TransactionType,email){

//   return this.service.create(environment.RefundTransactionUrl+"?tranType="+TransactionType+"&Email="+email,data);
// }
RefundTransaction(data,TransactionType,email){
  this. GetHeaderdetails();
  return this.http.post<any>(environment.RefundTransactionUrl+"?tranType="+TransactionType+"&Email="+email,data,{headers:this.headers}); 
}

StatusCheck(data,email)
{
  this. GetHeaderdetails();
  return this.http.post(environment.CheckUpiStatusUrl+"?Email="+email,data,{headers:this.headers});
}

  CaptureTransaction(data,TransactionType,email)
  {
    this. GetHeaderdetails();
    return this.http.post(environment.CaptureTransactionUrl+"?tranType="+TransactionType+"&Email="+email,data,{headers:this.headers});
  }
  getStoreCards(merchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return  this.http.get<VposPrepaidCardsAppView>(environment.getStoreCardsByMerchantId+'?MerchantKeyId='+merchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers});          

  }
  getStoreCardByCardNo(CardNo,merchantKeyId) 
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposPrepaidCardsAppView>(environment.getStoreCardByCardNo+"?CardNo="+CardNo+"&MerchantKeyId="+merchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  } 

   ViewTransactionDetails(data,MerchantKeyId,batchId,paymentType)
  {this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<TransactionDetailModel>(environment.getTransactionDetailsByTypeUrl+"?id="+data+"&MerchantKeyId="+MerchantKeyId+"&BatchId="+batchId+"&PaymentType="+paymentType+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  } 

  // UserPreferenceSettings(MerchantKeyId,UserId)
  // {
  //   return this.http.get<any>(environment.GetUserPreferenceSettingsUrl+"?MerchantKeyId="+MerchantKeyId+"&UserId="+UserId)  
  //   .map(response => response)    
  //   .catch(this.common.handleError);
  // } 

  UserPreferenceSettings(MerchantKeyId,UserId) {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.GetUserPreferenceSettingsUrl+"?MerchantKeyId="+MerchantKeyId+"&UserId="+UserId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})   
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  }
  GetChargebackDetails(MerchantKeyId,TransactionId) {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetChargebackbytransactionId+"?MerchantKeyId="+MerchantKeyId+"&TransactionId="+TransactionId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})   
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  }

  viewFilterdata(fromdate,todate,transactionStatus)
  {
    this. GetHeaderdetails();
    // return this.http.get(environment.viewFilterdataurl+"&fromdate="+fromdate+"&transactionStatus="+transactionStatus+"&todate="+todate) 
     return this.http.get(environment.viewFilterdataurl+"?fromdate="+fromdate+"&todate="+todate+"&transactionStatus="+transactionStatus
     ,{headers:this.headers})   
     .pipe(map(response => response)    
     ,catchError(this.common.handleError));
  } 

  public getIPAddress()
  {
    return this.http.get("http://api.ipify.org/?format=json");
  }
 
  GetuserPermissions(userId)
  {
    return this.http.get(environment.getUserPermissions+"?UserId="+userId)   
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  }
  filterOrderFailureLogsUrl(data) {
      this. GetHeaderdetails();
    return this.http.post<any>(environment.filterOrderFailureLogsUrl, data, { headers: this.headers })
  }
  
  GetuserRoleBasedPermissions(userId, appName) {
    if (!this.userRolePermissionsCache) {
      this.GetHeaderdetails();
      const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.getUserRoleBasedPermissions+"?UserId="+userId+"&AppName="+appName+"&LoginUserId="+merchantdata.UserId+"&MerchantKeyId="+merchantdata.MerchantKeyId,{headers:this.headers})
    }
    return this.userRolePermissionsCache;
  }

  
  UpdateManageTransactionSettings(MerchantKeyId,UserId,Module) {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.UpdateManageTransactionSettingsUrl+"?MerchantKeyId="+MerchantKeyId+"&UserId="+UserId+"&Type="+Module+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})   
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  }

  GetUserPreferenceSettings(MerchantKeyId,UserId) {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.GetUserPreferenceSettingsUrl+"?MerchantKeyId="+MerchantKeyId+"&UserId="+UserId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})   
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  }
  // public RefundTransaction(data){
  //   console.log("data",data);
    
  //   return this.http.post<any>(environment.RefundTransactionUrl , data);
  // }

  ViewPaymentOrderDetails(orderid,MerchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PaymentOrderDetailsModel>(environment.viewPaymentOrderDetailsUrl+"?id="+orderid+"&MerchantKeyId="+MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  } 
  GetOrderDetails(OrderKeyId,MerchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PaymentOrderDetailsModel>(environment.GetOrderDetails+"?OrderKeyId="+OrderKeyId+"&MerchantKeyId="+MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})
    .pipe(map(response => response)    
    ,catchError(this.common.handleError));
  } 
  GetSplitOrderDetails(OrderKeyId,MerchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PaymentOrderDetailsModel>(environment.GetSplitOrderDetails+"?OrderKeyId="+OrderKeyId+"&MerchantKeyId="+MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})
    .pipe(map(response => response)    
    ,catchError(this.common.handleError));
  } 
  CancelOrderDetails(OrderKeyId,MerchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PaymentOrderDetailsModel>(environment.CancelOrderDetails+"?OrderKeyId="+OrderKeyId+"&MerchantKeyId="+MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  } 

SplitOrderDetails(OrderKeyId,MerchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PaymentOrderDetailsModel>(environment.SplitOrderDetails+"?OrderKeyId="+OrderKeyId+"&MerchantKeyId="+MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  } 
  

  NewTransaction(data) {
    return this.http.post<any>(environment.NewAchTransactionUrl, data);
  }


  ManagePaymentOrdersUrl(MerchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.ManagePaymentOrdersUrl+"?MerchantKeyId="+MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  } 


  getrefundtransactions(Mid,Transactiontype){
    
      this. GetHeaderdetails();
      return this.http.get<any>(environment.getrefundtransactionsurl+"?MerchantKeyId="+Mid+ "&TransactionType=" + Transactiontype,{headers:this.headers})  
      .pipe(map(response => response)    
   ,catchError(this.common.handleError));
    
  }
  gettransactiondata(Mid,orderkeyid,tid){
    this. GetHeaderdetails();
    return this.http.get<any>(environment.gettransactiondatasurl+"?MerchantKeyId="+Mid+ "&orderkeyid=" + orderkeyid+ "&transactionid=" + tid,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  
}
  getCurrentMonthStatementDetailsUrl(MerchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getCurrentMonthStatementDetailsUrl+"?MerchantKeyId="+MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
    
  }
  ManageMerchantStatementsUrl(MerchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.ManageMerchantStatementsUrl+"?MerchantKeyId="+MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
    
  }


  getMerchantStatementDetailsUrl(MerchantKeyId,statementViewId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getMerchantStatementDetailsUrl+"?MerchantKeyId="+MerchantKeyId+"&Id="+statementViewId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
    
  }
  getTransactionSummaryReportUrl(MerchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>( environment.getTransactionSummaryReportUrl + "?MerchantkeyId=" + MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
   
  }
  filterPaymentOrdersUrl(data)
  {
    this. GetHeaderdetails();
    // const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    // return this.http.get<any>(environment.filterPaymentOrdersUrl+"?MerchantKeyId="+MerchantKeyId+"&Id="+txtId +"&fromdate=" + Fromdate1 + "&todate=" + todate1
    //  + "&OrderKeyId=" + txtOrderKeyId + "&UniqueRequestId=" + txtUniqueRequestId + "&OrderAmount=" + txtOrderAmount + "&OrderStatusText=" + txtOrderStatusText + "&AmountCheck=" + amountcompare  + "&PaymentModule=" + PaymentModule+"&orderId="+orderId+ "&LoginUserId="+merchantdata.UserId
    //  ,{headers:this.headers})  
    //.map(response => response)    
   // .catch(this.common.handleError);
    return this.http.post<any>(environment.filterPaymentOrdersUrl,data,{headers:this.headers});
  }


  GetTransactionUrl(MerchantKeyId)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>( environment.GetTransactionUrl + "?MerchantkeyId=" + MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
   
  }
  gettransactiondetails(MerchantKeyId,Requestuniqueid)
  {
    this. GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();

    return this.http.get<any>( environment.gettransactiondetails + "?MerchantkeyId=" + MerchantKeyId + "&requestuniqueid=" + Requestuniqueid+ "&LoginUserId="+merchantdata.UserId
    ,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
   
  }
  viewFilterdataurl(data)
  {
    this.GetHeaderdetails();
   return this.http.post<any>(environment.viewFilterdataurl,data,{headers:this.headers})
  }

  
 GetHeaderdetails()
 {
   let loggedUsername =this.common.getUserName()
   const merchantdata: UserMerchantData = this.common.getUserMerchantData();
   this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+":"+merchantdata.MerchantKeyId;
   this.headers = new HttpHeaders().
   set('Authorization', 'basic ' + btoa(this.token));


 }


 GetUserAuthdetails()
 {
   this.token = "" + ":" + environment.GetAuthenticationToken + ":" +'IT';
   this.headers = new HttpHeaders().
   set('Authorization', 'basic ' + btoa(this.token));
 } 
 Inserticketmaster(data)
 {
   this.GetHeaderdetails();
   return this.http.post<any>(environment.AddSupportTicketUrl,data,{ headers:this.headers });
 }
 Inserticketdetails(data)
 {
   this.GetHeaderdetails();
   return this.http.post<any>(environment.Addticketdetailsurl,data,{ headers:this.headers });
 }

 IsRaisedSupportTicket(MerchantKeyId,TransactionId)
  {
    this.GetHeaderdetails();
    return this.http.get<any>(environment.IsraisedsupportTicket + "?MerchantkeyId=" + MerchantKeyId + "&TransactionId=" + TransactionId,{headers:this.headers})  
    .pipe(map(response => response)    
   ,catchError(this.common.handleError));
   
  }
 GetInstantPaymentTransactions(MerchantKeyId)
 {
   this. GetHeaderdetails();
   return this.http.get<any>( environment.GetInstantPaymentTransactionUrl + "?MerchantkeyId=" + MerchantKeyId,{headers:this.headers})  
   .pipe(map(response => response)    
   ,catchError(this.common.handleError));
  
 }
}
